import { CourseDef } from '../../../../types';
import L2079373 from './2079373';
import L3893645 from './3893645';
import L4312953 from './4312953';
// import L5234368 from './5234368';
import L5234369 from './5234369';

export const gestaoFinanceira: CourseDef = {
  courseTitle: 'GESTÃO FINANCEIRA',
  lessons: [
    L2079373,
    L3893645,
    L4312953,
    // L5234368,
    L5234369,
  ],
};

